<template>
  <div>
    <Form
      ref="formRef" :model="formData"
      :rules="ruleValidate" :label-width="80"
    >
      <FormItem
        label="无效原因" prop="type"
      >
        <Select v-model="formData.type" placeholder="请选择无效原因">
          <Option
            v-for="item in judgeTypeArr" :key="item.value"
            :value="item.value"
          >
            {{ item.nameZh }}
          </Option>
        </Select>
      </FormItem>
      <FormItem
        v-if="formData.type==='OT'" label="具体原因"
        prop="reason"
      >
        <Input
          v-model="formData.reason" type="textarea"
          :autosize="{minRows: 3,maxRows: 5}" placeholder="请填写具体原因"
        />
      </FormItem>
      <FormItem style="text-align: center;">
        <Button
          type="primary" :loading="loading"
          @click="handleSubmit('formRef')"
        >确认</Button>
        <Button style="margin-left: 8px" @click="$emit('close', false)">取消</Button>
      </FormItem>
    </Form>
  </div>
</template>

<script>
export default {
  name: 'Withdraw',
  props: ['caseidList', 'drawType', 'isBatch'],
  data() {
    return {
      loading: false,
      judgeTypeArr: [],
      formData: {
        type: '',
        reason: ''
      },
      ruleValidate: {
        type: [{ required: true, message: '请选择无效原因', trigger: 'change' }],
        reason: [{ required: true, message: '请填写具体原因', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.getDictionary()
  },
  methods: {
    handleSubmit(name) {
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          this.loading = true
          const ajaxData = this.formData.type === 'OT' ? {
            itemIds: this.caseidList,
            ...this.formData
          } : {
            itemIds: this.caseidList,
            type: this.formData.type
          }
          const url = this.drawType === 'unSubmited' ? '/business/case/judgment/material/back-redo' : '/business/case/judgment/material/back'
          const res = await this.$post(url, ajaxData)
          this.loading = false
          if (res.code === 0) {
            const tip = ['RO', 'DO', 'RE', 'RI', 'AP'].includes(this.formData.type) ? '撤回成功，请填写相关节点信息' : '操作成功'
            this.$Message.success(tip)
            if (!this.isBatch) {
              // 不是批量撤回才跳转案件详情
              if (['RO', 'DO', 'RE', 'RI', 'AP'].includes(this.formData.type)) this.$emit('goCaseDetail')
            }
            this.$emit('close', true)
          } else {
            this.$Message.error(res.message || '未知错误')
          }
        }
      })
    },
    // 获取字典数据接口
    async getDictionary() {
      this.judgeTypeArr = await this.common.getDictionaryItems('judge_back_type')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/carryoutMaterialManage/components/withdraw.vue